module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/for-sale-property-pin-4ddff2012a124dac6d886851364c88df.svg";